import type { FieldErrors } from 'react-hook-form';
import type { Props as ReactSelectProps, SingleValue, StylesConfig } from 'react-select';

export type SelectorOption<
  Value extends string | number | null,
  Extra extends Record<string, unknown> = Record<string, unknown>,
> = Partial<Extra> & {
  value: Value | null;
  label: string;
  icon?: React.ReactNode;
  image?: string;
  subtitle?: string;
  actionNode?: React.ReactNode;
};

export const SelectorOptionTypes = {
  DEFAULT: 'default',
  IMAGE: 'image',
  CHECK_ICON: 'check-icon',
} as const;

export type SelectorOptionType = (typeof SelectorOptionTypes)[keyof typeof SelectorOptionTypes];

export interface SelectorProps<Value extends string | number>
  extends Omit<ReactSelectProps<SelectorOption<Value>, false>, 'options' | 'value' | 'onChange'> {
  errors?: FieldErrors;
  intent?: 'default' | 'old';
  optionType?: SelectorOptionType;
  name?: string;
  label?: string;
  options: SelectorOption<Value | null>[];
  option?: SelectorOption<Value | null> | null;
  value: Value | null;
  onChange: (newValue: SingleValue<SelectorOption<Value | null>>) => void;
  customStyles?: Partial<StylesConfig<SelectorOption<Value | null>, false>>;
  disabled?: boolean;
  helperText?: string;
  isClearOption?: boolean;
  clearOptionLabel?: string;
}

export interface SelectorSaveOnBlurProps<Value extends string | number> extends SelectorProps<Value> {
  invalid?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  setSearchValue?: (val: string) => void;
  helperText?: string;
}